export const bottomMenu = [
	{
		bottomMenuLink: '#',
	},
	{
		bottomMenuCap: 'Privacy Policy',
		bottomMenuLink: '#',
	},
];
